module.exports = __webpack_public_path__ + "static/media/31.d3ca2625.jpeg";